export enum PhaseFormTabTypes {
  DETAILS = 'DETAILS',
  ACCESS = 'ACCESS',
  VOTING = 'VOTING',
  QUESTIONS = 'QUESTIONS'
}
